// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.label-input[data-v-3952a3ef] {\n  font-size: 1rem;\n  color: #757575;\n  margin-bottom: 0.5rem;\n}\n.push-top-item-header[data-v-3952a3ef] {\n  margin-top: 1.9rem;\n}\n.refresh[data-v-3952a3ef] {\n  font-size: 3rem;\n  color: #757575;\n}\n", ""]);
// Exports
module.exports = exports;
